export const PUBLIC_ROUTE = {
    path: 'public',
    get url(): string[] {
        return ['', this.path];
    }
};



export const LAYOUT_ROUTE = {
    path: 'admin',
    get url(): string[] {
        return ['', this.path];
    },
};

export const LOAN_SUCCESS_ROUTE = {
    path: 'success',
    get url(): string[] {
        return [LAYOUT_ROUTE.path, this.path];
    }
};

export const NOT_FOUND_ROUTE = {
    path: 'not-found',
    get url(): string[] {
        return ['', this.path];
    },
};

export const NO_INTERNET_ROUTE = {
    path: 'no-internet',
    get url(): string[] {
        return ['', this.path];
    },
};

export const LINK_EXPIRED_ROUTE = {
    path: 'link-expired',
    get url(): string[] {
        return ['', this.path];
    },
};

export const SOMETHING_WRONG_ROUTE = {
    path: 'something-wrong',
    get url(): string[] {
        return ['', this.path];
    },
};